import { render, staticRenderFns } from "./layout.vue?vue&type=template&id=4a4d3ab9&scoped=true&"
import script from "./layout.vue?vue&type=script&lang=js&"
export * from "./layout.vue?vue&type=script&lang=js&"
import style1 from "./layout.vue?vue&type=style&index=1&id=4a4d3ab9&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a4d3ab9",
  null
  
)

export default component.exports